import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); const [ready, setReady] = useState(false);
  useEffect(() => { const token = localStorage.getItem("orv_token"); if (!token) { setUser(false); setReady(true); return; } api.get("/auth/me").then((res) => setUser(res.data.user)).catch(() => { localStorage.removeItem("orv_token"); setUser(false); }).finally(() => setReady(true)); }, []);
  const acceptAuth = (data) => { localStorage.setItem("orv_token", data.token); setUser(data.user); return data.user; };
  const login = async (email, password) => acceptAuth((await api.post("/auth/login", { email, password })).data);
  const startRegistration = async (name, email, password) => (await api.post("/auth/register", { name, email, password })).data;
  const verifyRegistration = async (name, email, password, otp) => acceptAuth((await api.post("/auth/register/verify", { name, email, password, otp })).data);
  const register = verifyRegistration;
  const logout = () => { localStorage.removeItem("orv_token"); setUser(false); };
  const refreshUser = async () => { try { setUser((await api.get("/auth/me")).data.user); } catch (e) { /* ignore */ } };
  return <AuthContext.Provider value={{ user, ready, login, register, startRegistration, verifyRegistration, logout, refreshUser, isAuthed: !!user }}>{children}</AuthContext.Provider>;
};

